import React, { useEffect, useState } from "react";
import * as cls from "./courseDetail.module.scss";

const CourseDetail = ({ course }) => {
  const [expanded, setExpanded] = useState({});

  const handleToggle = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    course.list.forEach((el, index) => {
      if (el.list.length > 0) {
        setExpanded((prev) => ({
          ...prev,
          [index]: true,
        }));
      } else {
        setExpanded((prev) => ({
          ...prev,
          [index]: false,
        }));
      }
    });
  }, [course.list]);

  const renderNotification = (notification) => {
    if (notification && notification.text) {
      return (
        <div className={cls.notificationText} title={notification.text}>
          {notification.text}
        </div>
      );
    }
    return null;
  };

  return (
    <div className={cls.container}>
      {course.list.map((semester, index) => (
        <div className={cls.items} key={index}>
          <div className={cls.accordionHeader}>
            {semester.list.length > 0 ? (
              <div className={cls.btn} onClick={() => handleToggle(index)}>
                {expanded[index] ? "-" : "+"}
              </div>
            ) : (
              <div
                className={cls.btnEmpty}
                onClick={() => handleToggle(index)}
              ></div>
            )}
            <div className={cls.semesterName}>
              {semester.name} /{" "}
              {new Date(semester.start_date).toLocaleDateString()} -{" "}
              {new Date(semester.end_date).toLocaleDateString()}
            </div>
          </div>
          {expanded[index] && (
            <div className={cls.accordionDetails}>
              <div className={cls.detailItems}>
                {semester.list.map((event, idx) => (
                  <div className={cls.item} key={idx}>
                    <p style={{ flex: 1, marginLeft: "20px" }}>{idx + 1}</p>
                    <p style={{ flex: 10 }}>{event.name} </p>
                    <p style={{ flex: 5 }}>
                      {event.date_text ? (
                        event.date_text
                      ) : (
                        <>
                          {new Date(event.start_date).toLocaleDateString()} -{" "}
                          {new Date(event.end_date).toLocaleDateString()}
                        </>
                      )}
                    </p>
                    <div className={cls.notificationContainer}>
                      {renderNotification(event.notification)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CourseDetail;
